import { ResponsePageable } from './../../model/cliente/pageable/responsePageable.model';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CentroCustoModel } from 'app/model/cliente/centrocusto.model';

@Injectable()
export class CentroCustoService {

  apiURL = environment.API;

  httpOptions = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(
    private httpCliente: HttpClient
  ) { }

  getListaCentroCusto(page: number, size: number): Observable<ResponsePageable> {
    return this.httpCliente.get<ResponsePageable>(this.apiURL + `/view/listar-centro-custo?page=${page}&size=${size}`, this.httpOptions);
  }

  getListaCentroCustoNoPage(): Observable<ResponsePageable> {
    return this.httpCliente.get<ResponsePageable>(this.apiURL + `/view/listar-centro-custo`, this.httpOptions);
  }

  postCentroCusto(centroCusto: CentroCustoModel): Observable<CentroCustoModel> {
    return this.httpCliente.post<CentroCustoModel>(this.apiURL + '/new/adicionar-centro-custo', centroCusto, this.httpOptions);
  }

  putCentroCusto(centroCusto: CentroCustoModel): Observable<CentroCustoModel> {
    return this.httpCliente.put<CentroCustoModel>(this.apiURL + '/edit/editar-centro-custo', centroCusto, this.httpOptions);
  }

  getCentrosCusto() {
    return this.httpCliente.get<any>(this.apiURL + '/view/listar-todos-centros', this.httpOptions);
  }

  deleteCentroCusto(id: any) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpCliente.delete(this.apiURL + '/delete/apagar-centro-custo/' + id , {responseType: 'text', headers});
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/centro-custo.service.ts